// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../api/axiosInstance";
// import { toast } from "react-hot-toast";

// const MembershipDetails = () => {
//   const [member, setMember] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState("overview");
//   const navigate = useNavigate();

//   const fetchProfile = async () => {
//     try {
//       const res = await api.get("/profile");
//       const memberData = res.data.member || res.data;
//       setMember(memberData);
//     } catch (error) {
//       console.error("Error fetching profile:", error);
//       toast.error("Failed to load membership details");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProfile();
//   }, []);

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "ACTIVE":
//         return "bg-green-100 text-green-800";
//       case "APPROVED_AWAITING_PAYMENT":
//         return "bg-yellow-100 text-yellow-800";
//       case "PENDING_ADMIN_APPROVAL":
//         return "bg-blue-100 text-blue-800";
//       case "PENDING_VERIFICATION":
//         return "bg-gray-100 text-gray-800";
//       case "REJECTED":
//         return "bg-red-100 text-red-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   const getPaymentStatusColor = (status) => {
//     switch (status) {
//       case "SUCCESS":
//         return "bg-green-100 text-green-800";
//       case "PENDING":
//         return "bg-yellow-100 text-yellow-800";
//       case "FAILED":
//         return "bg-red-100 text-red-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   const getMembershipBenefits = (category, type) => {
//     const benefits = {
//       FULL_MEMBERSHIP: [
//         "Unlimited golf course access",
//         "Priority tee time booking",
//         "Access to all club facilities",
//         "Complimentary guest passes (4 per month)",
//         "Discounts on pro shop purchases",
//         "Invitation to member-only events",
//         "Locker room access",
//       ],
//       TEMPORARY_MEMBERSHIP: [
//         "Limited golf course access (weekdays only)",
//         "Basic facility access",
//         "2 guest passes per month",
//         "Pro shop discounts (10%)",
//         "Event participation (additional fees may apply)",
//       ],
//       CORPORATE_MEMBERSHIP: [
//         "Multiple user access (up to 5 employees)",
//         "Business event hosting privileges",
//         "Corporate branding opportunities",
//         "Priority booking for corporate events",
//         "Complimentary meeting room usage",
//         "Enhanced guest passes",
//       ],
//       HONORARY_MEMBERSHIP: [
//         "Full golf course access",
//         "All club facilities access",
//         "Complimentary guest privileges",
//         "VIP event invitations",
//         "Lifetime locker assignment",
//       ],
//     };

//     return (
//       benefits[type] || [
//         "Basic golf course access",
//         "Standard facility usage",
//         "Member event participation",
//       ]
//     );
//   };

//   const getCategoryDescription = (category) => {
//     const descriptions = {
//       SERVING_DEFENCE_OFFICER:
//         "Active military personnel serving in defence forces",
//       RETIRED_DEFENCE_OFFICER:
//         "Honorary membership for retired defence personnel",
//       GOVERNMENT_OFFICER: "Civil servants and government employees",
//       NON_MILITARY: "Civilian members from various professions",
//       CORPORATE_BUSINESS: "Business entities and corporate representatives",
//       FOREIGNER_DIPLOMAT: "International members and diplomatic personnel",
//     };
//     return descriptions[category] || "Golf club membership";
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-100 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading membership details...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100">
//       {/* Header */}
//       <header className="bg-white shadow-sm">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center py-4">
//             <div>
//               <button
//                 onClick={() => navigate("/dashboard")}
//                 className="flex items-center text-gray-600 hover:text-gray-900 mb-2"
//               >
//                 <svg
//                   className="w-3 h-4 mr-1"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 19l-7-7 7-7"
//                   />
//                 </svg>
//                 Back to Dashboard
//               </button>
//               <h1 className="text-2xl font-bold text-gray-900">
//                 Membership Details
//               </h1>
//               <p className="text-gray-600">
//                 Your RGCC membership information and benefits
//               </p>
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {/* Membership Overview Card */}
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
//           <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
//             <div>
//               <h2 className="text-xl font-semibold text-gray-900">
//                 {member.firstName} {member.lastName}
//               </h2>
//               <p className="text-gray-600 mt-1">Member ID: {member.userId}</p>
//               <p className="text-gray-500 text-sm mt-1">
//                 {getCategoryDescription(member.membershipCategory)}
//               </p>
//             </div>
//             <div className="flex flex-wrap gap-2 mt-4 md:mt-0">
//               <span
//                 className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(
//                   member.registrationStatus
//                 )}`}
//               >
//                 {member.registrationStatus.replace(/_/g, " ")}
//               </span>
//               <span
//                 className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getPaymentStatusColor(
//                   member.paymentStatus
//                 )}`}
//               >
//                 Payment: {member.paymentStatus}
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Tab Navigation */}
//         <div className="bg-white rounded-lg shadow-sm mb-6">
//           <div className="border-b border-gray-200">
//             <nav className="flex -mb-px">
//               <button
//                 onClick={() => setActiveTab("overview")}
//                 className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
//                   activeTab === "overview"
//                     ? "border-green-500 text-green-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//               >
//                 Overview
//               </button>
//               <button
//                 onClick={() => setActiveTab("benefits")}
//                 className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
//                   activeTab === "benefits"
//                     ? "border-green-500 text-green-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//               >
//                 Benefits
//               </button>
//               <button
//                 onClick={() => setActiveTab("documents")}
//                 className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
//                   activeTab === "documents"
//                     ? "border-green-500 text-green-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//               >
//                 Documents
//               </button>
//             </nav>
//           </div>
//         </div>

//         {/* Overview Tab */}
//         {activeTab === "overview" && (
//           <div className="space-y-6">
//             {/* Membership Status Card */}
//             <div className="bg-white rounded-lg shadow-sm p-6">
//               <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                 Membership Status
//               </h3>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//                 <div className="bg-gray-50 p-4 rounded-lg">
//                   <p className="text-sm text-gray-600">Membership Category</p>
//                   <p className="font-semibold text-gray-900">
//                     {member.membershipCategory}
//                   </p>
//                 </div>
//                 <div className="bg-gray-50 p-4 rounded-lg">
//                   <p className="text-sm text-gray-600">Membership Type</p>
//                   <p className="font-semibold text-gray-900">
//                     {member.membershipType}
//                   </p>
//                 </div>
//                 <div className="bg-gray-50 p-4 rounded-lg">
//                   <p className="text-sm text-gray-600">Registration Status</p>
//                   <p className="font-semibold text-gray-900">
//                     {member.registrationStatus.replace(/_/g, " ")}
//                   </p>
//                 </div>
//                 <div className="bg-gray-50 p-4 rounded-lg">
//                   <p className="text-sm text-gray-600">Payment Status</p>
//                   <p
//                     className={`font-semibold ${
//                       member.paymentStatus === "SUCCESS"
//                         ? "text-green-600"
//                         : member.paymentStatus === "PENDING"
//                         ? "text-yellow-600"
//                         : "text-red-600"
//                     }`}
//                   >
//                     {member.paymentStatus}
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Membership Timeline */}
//             <div className="bg-white rounded-lg shadow-sm p-6">
//               <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                 Membership Journey
//               </h3>
//               <div className="space-y-4">
//                 <div className="flex items-center">
//                   <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
//                     <svg
//                       className="w-4 h-4 text-green-600"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <p className="text-sm font-medium text-gray-900">
//                       Registration Submitted
//                     </p>
//                     <p className="text-sm text-gray-500">
//                       Your membership application has been received
//                     </p>
//                   </div>
//                 </div>

//                 <div className="flex items-center">
//                   <div
//                     className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
//                       member.registrationStatus === "PENDING_VERIFICATION"
//                         ? "bg-gray-100"
//                         : "bg-green-100"
//                     }`}
//                   >
//                     {member.registrationStatus !== "PENDING_VERIFICATION" ? (
//                       <svg
//                         className="w-4 h-4 text-green-600"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M5 13l4 4L19 7"
//                         />
//                       </svg>
//                     ) : (
//                       <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
//                     )}
//                   </div>
//                   <div className="ml-4">
//                     <p className="text-sm font-medium text-gray-900">
//                       Email Verification
//                     </p>
//                     <p className="text-sm text-gray-500">
//                       Email address verified successfully
//                     </p>
//                   </div>
//                 </div>

//                 <div className="flex items-center">
//                   <div
//                     className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
//                       [
//                         "PENDING_ADMIN_APPROVAL",
//                         "APPROVED_AWAITING_PAYMENT",
//                         "ACTIVE",
//                       ].includes(member.registrationStatus)
//                         ? "bg-green-100"
//                         : "bg-gray-100"
//                     }`}
//                   >
//                     {["APPROVED_AWAITING_PAYMENT", "ACTIVE"].includes(
//                       member.registrationStatus
//                     ) ? (
//                       <svg
//                         className="w-4 h-4 text-green-600"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M5 13l4 4L19 7"
//                         />
//                       </svg>
//                     ) : member.registrationStatus ===
//                       "PENDING_ADMIN_APPROVAL" ? (
//                       <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
//                     ) : (
//                       <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
//                     )}
//                   </div>
//                   <div className="ml-4">
//                     <p className="text-sm font-medium text-gray-900">
//                       Admin Approval
//                     </p>
//                     <p className="text-sm text-gray-500">
//                       {member.registrationStatus === "PENDING_ADMIN_APPROVAL"
//                         ? "Awaiting administrative review"
//                         : "Application approved by administration"}
//                     </p>
//                   </div>
//                 </div>

//                 <div className="flex items-center">
//                   <div
//                     className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
//                       member.registrationStatus === "ACTIVE"
//                         ? "bg-green-100"
//                         : member.registrationStatus ===
//                           "APPROVED_AWAITING_PAYMENT"
//                         ? "bg-yellow-100"
//                         : "bg-gray-100"
//                     }`}
//                   >
//                     {member.registrationStatus === "ACTIVE" ? (
//                       <svg
//                         className="w-4 h-4 text-green-600"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M5 13l4 4L19 7"
//                         />
//                       </svg>
//                     ) : member.registrationStatus ===
//                       "APPROVED_AWAITING_PAYMENT" ? (
//                       <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
//                     ) : (
//                       <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
//                     )}
//                   </div>
//                   <div className="ml-4">
//                     <p className="text-sm font-medium text-gray-900">
//                       Payment & Activation
//                     </p>
//                     <p className="text-sm text-gray-500">
//                       {member.registrationStatus === "ACTIVE"
//                         ? "Payment completed and membership activated"
//                         : member.registrationStatus ===
//                           "APPROVED_AWAITING_PAYMENT"
//                         ? "Complete payment to activate membership"
//                         : "Pending previous steps"}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Quick Actions */}
//             {member.registrationStatus === "APPROVED_AWAITING_PAYMENT" && (
//               <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
//                 <div className="flex items-center">
//                   <div className="flex-shrink-0">
//                     <svg
//                       className="w-6 h-6 text-yellow-600"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-3">
//                     <h3 className="text-lg font-medium text-yellow-800">
//                       Payment Required
//                     </h3>
//                     <p className="text-yellow-700 mt-1">
//                       Your membership has been approved! Complete the payment to
//                       activate your membership and unlock all features.
//                     </p>
//                     <button
//                       onClick={() => navigate("/payment-checkout")}
//                       className="mt-3 bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700 transition"
//                     >
//                       Complete Payment
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Benefits Tab */}
//         {activeTab === "benefits" && (
//           <div className="bg-white rounded-lg shadow-sm p-6">
//             <h3 className="text-lg font-semibold text-gray-900 mb-6">
//               Membership Benefits
//             </h3>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {/* Included Benefits */}
//               <div>
//                 <h4 className="text-md font-semibold text-gray-900 mb-4">
//                   Your Benefits
//                 </h4>
//                 <ul className="space-y-3">
//                   {getMembershipBenefits(
//                     member.membershipCategory,
//                     member.membershipType
//                   ).map((benefit, index) => (
//                     <li key={index} className="flex items-start">
//                       <svg
//                         className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M5 13l4 4L19 7"
//                         />
//                       </svg>
//                       <span className="text-gray-700">{benefit}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>

//               {/* Membership Information */}
//               <div className="bg-gray-50 rounded-lg p-6">
//                 <h4 className="text-md font-semibold text-gray-900 mb-4">
//                   Membership Information
//                 </h4>
//                 <dl className="space-y-3">
//                   <div>
//                     <dt className="text-sm font-medium text-gray-600">
//                       Category
//                     </dt>
//                     <dd className="text-sm text-gray-900">
//                       {member.membershipCategory}
//                     </dd>
//                   </div>
//                   <div>
//                     <dt className="text-sm font-medium text-gray-600">Type</dt>
//                     <dd className="text-sm text-gray-900">
//                       {member.membershipType}
//                     </dd>
//                   </div>
//                   <div>
//                     <dt className="text-sm font-medium text-gray-600">
//                       Status
//                     </dt>
//                     <dd className="text-sm">
//                       <span
//                         className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
//                           member.registrationStatus
//                         )}`}
//                       >
//                         {member.registrationStatus.replace(/_/g, " ")}
//                       </span>
//                     </dd>
//                   </div>
//                   <div>
//                     <dt className="text-sm font-medium text-gray-600">
//                       Description
//                     </dt>
//                     <dd className="text-sm text-gray-900">
//                       {getCategoryDescription(member.membershipCategory)}
//                     </dd>
//                   </div>
//                 </dl>
//               </div>
//             </div>

//             {/* Additional Information */}
//             <div className="mt-8 pt-6 border-t border-gray-200">
//               <h4 className="text-md font-semibold text-gray-900 mb-4">
//                 Additional Information
//               </h4>
//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
//                 <p className="text-sm text-blue-800">
//                   <strong>Note:</strong> Some benefits may have usage
//                   restrictions or require prior booking. Please contact the club
//                   administration for detailed terms and conditions of your
//                   membership.
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Documents Tab */}
//         {activeTab === "documents" && (
//           <div className="bg-white rounded-lg shadow-sm p-6">
//             <h3 className="text-lg font-semibold text-gray-900 mb-6">
//               Membership Documents
//             </h3>

//             <div className="space-y-6">
//               {/* Membership Card */}
//               <div className="border border-gray-200 rounded-lg p-6">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <h4 className="text-md font-semibold text-gray-900">
//                       Digital Membership Card
//                     </h4>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Your virtual membership identification
//                     </p>
//                   </div>
//                   <button
//                     className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition text-sm"
//                     onClick={() =>
//                       toast.success(
//                         "Membership card download feature coming soon!"
//                       )
//                     }
//                   >
//                     Download Card
//                   </button>
//                 </div>
//                 <div className="mt-4 p-4 bg-gray-50 rounded-lg">
//                   <p className="text-sm text-gray-600">
//                     {member.registrationStatus === "ACTIVE"
//                       ? "Your digital membership card is available for download."
//                       : "Your digital membership card will be available once your membership is activated."}
//                   </p>
//                 </div>
//               </div>

//               {/* Terms and Conditions */}
//               <div className="border border-gray-200 rounded-lg p-6">
//                 <h4 className="text-md font-semibold text-gray-900 mb-2">
//                   Terms & Conditions
//                 </h4>
//                 <p className="text-sm text-gray-600 mb-4">
//                   Important documents regarding your membership agreement
//                 </p>
//                 <div className="space-y-3">
//                   <button
//                     className="w-full text-left p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
//                     onClick={() =>
//                       toast.success(
//                         "Membership terms document download coming soon!"
//                       )
//                     }
//                   >
//                     <div className="flex items-center justify-between">
//                       <div>
//                         <p className="text-sm font-medium text-gray-900">
//                           Membership Agreement
//                         </p>
//                         <p className="text-xs text-gray-500">
//                           Terms and conditions of your membership
//                         </p>
//                       </div>
//                       <svg
//                         className="w-5 h-5 text-gray-400"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                         />
//                       </svg>
//                     </div>
//                   </button>

//                   <button
//                     className="w-full text-left p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
//                     onClick={() =>
//                       toast.success("Club rules document download coming soon!")
//                     }
//                   >
//                     <div className="flex items-center justify-between">
//                       <div>
//                         <p className="text-sm font-medium text-gray-900">
//                           Club Rules & Regulations
//                         </p>
//                         <p className="text-xs text-gray-500">
//                           Code of conduct and facility usage rules
//                         </p>
//                       </div>
//                       <svg
//                         className="w-5 h-5 text-gray-400"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                         />
//                       </svg>
//                     </div>
//                   </button>
//                 </div>
//               </div>

//               {/* Uploaded Documents */}
//               <div className="border border-gray-200 rounded-lg p-6">
//                 <h4 className="text-md font-semibold text-gray-900 mb-4">
//                   Your Submitted Documents
//                 </h4>
//                 <div className="bg-gray-50 rounded-lg p-4">
//                   <p className="text-sm text-gray-600 text-center">
//                     Document management features coming soon. Your submitted
//                     documents are securely stored with the administration.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </main>
//     </div>
//   );
// };

// export default MembershipDetails;

import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosInstance";
import { toast } from "react-hot-toast";
import { AuthContext } from "../context/AuthContext";
import {
  ArrowLeft,
  User,
  Shield,
  CreditCard,
  CheckCircle,
  FileText,
  Calendar,
  Award,
  Star,
  Sparkles,
  Crown,
  Trophy,
  Users,
  Building,
  Globe,
  Mail,
  Phone,
  Clock,
  Download,
  ChevronRight,
  AlertCircle,
  Eye,
  Settings,
  QrCode,
  BadgeCheck,
  FileCheck,
} from "lucide-react";

const MembershipDetails = () => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("overview");
  const navigate = useNavigate();
  const { logout: logoutContext } = useContext(AuthContext);

  const fetchProfile = async () => {
    try {
      const res = await api.get("/profile");
      const memberData = res.data.member || res.data;
      setMember(memberData);
    } catch (error) {
      console.error("Error fetching profile:", error);
      toast.error("Session expired. Please log in again.");
      logoutContext();
      localStorage.clear();
      navigate("/login", { replace: true });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "ACTIVE":
        return "from-emerald-500 to-lime-500";
      case "APPROVED_AWAITING_PAYMENT":
        return "from-amber-500 to-orange-500";
      case "PENDING_ADMIN_APPROVAL":
        return "from-blue-500 to-cyan-500";
      case "PENDING_VERIFICATION":
        return "from-gray-500 to-gray-400";
      case "REJECTED":
        return "from-red-500 to-rose-500";
      default:
        return "from-gray-500 to-gray-400";
    }
  };

  const getPaymentStatusColor = (status) => {
    switch (status) {
      case "SUCCESS":
        return "from-emerald-500 to-lime-500";
      case "PENDING":
        return "from-amber-500 to-orange-500";
      case "FAILED":
        return "from-red-500 to-rose-500";
      default:
        return "from-gray-500 to-gray-400";
    }
  };

  const getMembershipBenefits = (category, type) => {
    const benefits = {
      FULL_MEMBERSHIP: [
        "Unlimited golf course access",
        "Priority tee time booking",
        "Access to all club facilities",
        "Complimentary guest passes (4 per month)",
        "Discounts on pro shop purchases",
        "Invitation to member-only events",
        "Locker room access",
      ],
      TEMPORARY_MEMBERSHIP: [
        "Limited golf course access (weekdays only)",
        "Basic facility access",
        "2 guest passes per month",
        "Pro shop discounts (10%)",
        "Event participation (additional fees may apply)",
      ],
      CORPORATE_MEMBERSHIP: [
        "Multiple user access (up to 5 employees)",
        "Business event hosting privileges",
        "Corporate branding opportunities",
        "Priority booking for corporate events",
        "Complimentary meeting room usage",
        "Enhanced guest passes",
      ],
      HONORARY_MEMBERSHIP: [
        "Full golf course access",
        "All club facilities access",
        "Complimentary guest privileges",
        "VIP event invitations",
        "Lifetime locker assignment",
      ],
    };

    return (
      benefits[type] || [
        "Basic golf course access",
        "Standard facility usage",
        "Member event participation",
      ]
    );
  };

  const getCategoryDescription = (category) => {
    const descriptions = {
      SERVING_DEFENCE_OFFICER:
        "Active military personnel serving in defence forces",
      RETIRED_DEFENCE_OFFICER:
        "Honorary membership for retired defence personnel",
      GOVERNMENT_OFFICER: "Civil servants and government employees",
      NON_MILITARY: "Civilian members from various professions",
      CORPORATE_BUSINESS: "Business entities and corporate representatives",
      FOREIGNER_DIPLOMAT: "International members and diplomatic personnel",
    };
    return descriptions[category] || "Golf club membership";
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case "SERVING_DEFENCE_OFFICER":
      case "RETIRED_DEFENCE_OFFICER":
        return <Shield className="w-5 h-5" />;
      case "GOVERNMENT_OFFICER":
        return <Building className="w-5 h-5" />;
      case "CORPORATE_BUSINESS":
        return <Users className="w-5 h-5" />;
      case "FOREIGNER_DIPLOMAT":
        return <Globe className="w-5 h-5" />;
      default:
        return <User className="w-5 h-5" />;
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "ACTIVE":
        return <CheckCircle className="w-5 h-5" />;
      case "APPROVED_AWAITING_PAYMENT":
        return <Clock className="w-5 h-5" />;
      case "PENDING_ADMIN_APPROVAL":
        return <Settings className="w-5 h-5" />;
      case "PENDING_VERIFICATION":
        return <Eye className="w-5 h-5" />;
      case "REJECTED":
        return <AlertCircle className="w-5 h-5" />;
      default:
        return <Clock className="w-5 h-5" />;
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-emerald-500 border-t-transparent mx-auto"></div>
          <p className="mt-6 text-lg text-gray-600">
            Loading your membership details...
          </p>
          <p className="text-sm text-gray-500 mt-2">
            Please wait while we fetch your information
          </p>
        </div>
      </div>
    );
  }

  if (!member) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Header */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-8 md:py-12 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8">
          {/* Back Button */}
          <button
            onClick={() => navigate("/dashboard")}
            className="inline-flex items-center gap-2 text-emerald-200 hover:text-white mb-6 group transition-colors duration-300"
          >
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span>Back to Dashboard</span>
          </button>

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3">
                Membership Details
              </h1>
              <p className="text-emerald-100 text-lg">
                Your RGCC membership information and exclusive benefits
              </p>
            </div>

            {/* Member Badge */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-emerald-300/30">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center">
                  <Crown className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-sm text-emerald-200">Member ID</p>
                  <p className="text-xl font-bold">{member.userId}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-8">
        {/* Member Overview Card */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 mb-8 border border-emerald-100">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
            <div className="flex items-start gap-6">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-30"></div>
                <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-4 border-white flex items-center justify-center shadow-2xl">
                  <User className="w-10 h-10 text-emerald-600" />
                </div>
              </div>

              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                  {member.firstName} {member.lastName}
                </h2>
                <p className="text-gray-600 mt-2 flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  {member.email}
                </p>
                <p className="text-gray-600 mt-1 flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  {member.phoneNumber || ""}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-3">
              <div
                className={`px-4 py-2 rounded-xl text-white font-semibold bg-gradient-to-r ${getStatusColor(
                  member.registrationStatus
                )}`}
              >
                <div className="flex items-center gap-2">
                  {getStatusIcon(member.registrationStatus)}
                  <span>{member.registrationStatus.replace(/_/g, " ")}</span>
                </div>
              </div>
              <div
                className={`px-4 py-2 rounded-xl text-white font-semibold bg-gradient-to-r ${getPaymentStatusColor(
                  member.paymentStatus
                )}`}
              >
                <div className="flex items-center gap-2">
                  <CreditCard className="w-4 h-4" />
                  <span>Payment: {member.paymentStatus}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg mb-8 border border-emerald-100 overflow-hidden">
          <div className="flex overflow-x-auto">
            <button
              onClick={() => setActiveTab("overview")}
              className={`flex items-center gap-3 px-6 py-4 font-medium text-sm md:text-base transition-all duration-300 flex-shrink-0 ${
                activeTab === "overview"
                  ? "bg-gradient-to-r from-emerald-500 to-lime-500 text-white"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
              }`}
            >
              <User className="w-5 h-5" />
              Overview
            </button>
            <button
              onClick={() => setActiveTab("benefits")}
              className={`flex items-center gap-3 px-6 py-4 font-medium text-sm md:text-base transition-all duration-300 flex-shrink-0 ${
                activeTab === "benefits"
                  ? "bg-gradient-to-r from-emerald-500 to-lime-500 text-white"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
              }`}
            >
              <Award className="w-5 h-5" />
              Benefits
            </button>
            <button
              onClick={() => setActiveTab("documents")}
              className={`flex items-center gap-3 px-6 py-4 font-medium text-sm md:text-base transition-all duration-300 flex-shrink-0 ${
                activeTab === "documents"
                  ? "bg-gradient-to-r from-emerald-500 to-lime-500 text-white"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
              }`}
            >
              <FileText className="w-5 h-5" />
              Documents
            </button>
          </div>
        </div>

        {/* Overview Tab */}
        {activeTab === "overview" && (
          <div className="space-y-8">
            {/* Membership Stats */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Sparkles className="w-6 h-6 text-emerald-500" />
                Membership Information
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="bg-gradient-to-br from-emerald-50 to-lime-50 rounded-xl p-5 border border-emerald-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center">
                      {getCategoryIcon(member.membershipCategory)}
                    </div>
                  </div>
                  <p className="text-sm text-gray-600">Category</p>
                  <p className="font-bold text-gray-900 text-lg">
                    {member.membershipCategory.replace(/_/g, " ")}
                  </p>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-5 border border-blue-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center">
                      <Crown className="w-5 h-5 text-white" />
                    </div>
                  </div>
                  <p className="text-sm text-gray-600">Type</p>
                  <p className="font-bold text-gray-900 text-lg">
                    {member.membershipType.replace(/_/g, " ")}
                  </p>
                </div>

                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-5 border border-amber-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-amber-500 to-orange-500 flex items-center justify-center">
                      <Calendar className="w-5 h-5 text-white" />
                    </div>
                  </div>
                  <p className="text-sm text-gray-600">Registration</p>
                  <p className="font-bold text-gray-900 text-lg">
                    {new Date(member.createdAt).toLocaleDateString()}
                  </p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-5 border border-purple-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                      <BadgeCheck className="w-5 h-5 text-white" />
                    </div>
                  </div>
                  <p className="text-sm text-gray-600">Status</p>
                  <div
                    className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold text-white bg-gradient-to-r ${getStatusColor(
                      member.registrationStatus
                    )}`}
                  >
                    {member.registrationStatus.replace(/_/g, " ")}
                  </div>
                </div>
              </div>
            </div>

            {/* Journey Timeline */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-8 flex items-center gap-3">
                <Trophy className="w-6 h-6 text-emerald-500" />
                Your Membership Journey
              </h3>

              <div className="relative">
                {/* Timeline Line */}
                <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gradient-to-b from-emerald-300 via-lime-300 to-emerald-300"></div>

                {/* Timeline Steps */}
                <div className="space-y-10">
                  {[
                    {
                      step: 1,
                      title: "Registration Submitted",
                      description:
                        "Your membership application has been received",
                      completed: true,
                      current:
                        member.registrationStatus === "PENDING_VERIFICATION",
                    },
                    {
                      step: 2,
                      title: "Email Verification",
                      description: "Email address verified successfully",
                      completed:
                        member.registrationStatus !== "PENDING_VERIFICATION",
                      current:
                        member.registrationStatus === "PENDING_VERIFICATION",
                    },
                    {
                      step: 3,
                      title: "Admin Approval",
                      description:
                        member.registrationStatus === "PENDING_ADMIN_APPROVAL"
                          ? "Awaiting administrative review"
                          : "Application approved by administration",
                      completed: [
                        "APPROVED_AWAITING_PAYMENT",
                        "ACTIVE",
                      ].includes(member.registrationStatus),
                      current:
                        member.registrationStatus === "PENDING_ADMIN_APPROVAL",
                    },
                    {
                      step: 4,
                      title: "Payment & Activation",
                      description:
                        member.registrationStatus === "ACTIVE"
                          ? "Payment completed and membership activated"
                          : member.registrationStatus ===
                            "APPROVED_AWAITING_PAYMENT"
                          ? "Complete payment to activate membership"
                          : "Pending previous steps",
                      completed: member.registrationStatus === "ACTIVE",
                      current:
                        member.registrationStatus ===
                        "APPROVED_AWAITING_PAYMENT",
                    },
                  ].map((journeyStep) => (
                    <div key={journeyStep.step} className="relative pl-16">
                      {/* Step Dot */}
                      <div className="absolute left-0">
                        <div
                          className={`w-12 h-12 rounded-full flex items-center justify-center ${
                            journeyStep.completed
                              ? "bg-gradient-to-r from-emerald-500 to-lime-500 text-white shadow-lg"
                              : journeyStep.current
                              ? "bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg"
                              : "bg-gray-200 text-gray-500"
                          }`}
                        >
                          {journeyStep.completed ? (
                            <CheckCircle className="w-6 h-6" />
                          ) : journeyStep.current ? (
                            <Clock className="w-6 h-6" />
                          ) : (
                            <span className="text-lg font-bold">
                              {journeyStep.step}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Step Content */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">
                          {journeyStep.title}
                        </h4>
                        <p className="text-gray-600">
                          {journeyStep.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Payment Required Banner */}
            {member.registrationStatus === "APPROVED_AWAITING_PAYMENT" && (
              <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl shadow-2xl p-6 md:p-8 text-white">
                <div className="flex flex-col md:flex-row md:items-center gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                      <CreditCard className="w-8 h-8" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">
                      Payment Required
                    </h3>
                    <p className="text-amber-100 mb-4">
                      Your membership has been approved! Complete the payment to
                      activate your membership and unlock all premium features
                      and benefits.
                    </p>
                    <button
                      onClick={() => navigate("/payment-checkout")}
                      className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-bold bg-white text-amber-600 hover:bg-amber-50 hover:scale-105 transition-all duration-300 shadow-lg"
                    >
                      <CreditCard className="w-5 h-5" />
                      Complete Payment
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Benefits Tab */}
        {activeTab === "benefits" && (
          <div className="space-y-8">
            {/* Benefits Overview */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
              <div className="flex flex-col lg:flex-row lg:items-start gap-8">
                {/* Benefits List */}
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                    <Award className="w-6 h-6 text-emerald-500" />
                    Your Membership Benefits
                  </h3>

                  <div className="space-y-4">
                    {getMembershipBenefits(
                      member.membershipCategory,
                      member.membershipType
                    ).map((benefit, index) => (
                      <div
                        key={index}
                        className="flex items-start gap-4 p-4 bg-gradient-to-r from-emerald-50/50 to-lime-50/50 rounded-xl border border-emerald-100 hover:border-emerald-200 transition-all duration-300"
                      >
                        <div className="w-8 h-8 rounded-full bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center flex-shrink-0">
                          <CheckCircle className="w-4 h-4 text-white" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-900">{benefit}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Membership Summary */}
                <div className="lg:w-96 flex-shrink-0">
                  <div className="bg-gradient-to-br from-emerald-50 to-lime-50 rounded-xl p-6 border border-emerald-100 shadow-lg">
                    <h4 className="text-lg font-bold text-gray-900 mb-6">
                      Membership Summary
                    </h4>

                    <div className="space-y-5">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center">
                          {getCategoryIcon(member.membershipCategory)}
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">Category</p>
                          <p className="font-bold text-gray-900">
                            {member.membershipCategory.replace(/_/g, " ")}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center">
                          <Crown className="w-5 h-5 text-white" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">Type</p>
                          <p className="font-bold text-gray-900">
                            {member.membershipType.replace(/_/g, " ")}
                          </p>
                        </div>
                      </div>

                      <div className="pt-4 border-t border-emerald-100">
                        <p className="text-sm text-gray-600 mb-2">
                          Description
                        </p>
                        <p className="text-gray-700">
                          {getCategoryDescription(member.membershipCategory)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl shadow-xl p-6 md:p-8 border border-blue-100">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center flex-shrink-0">
                  <Star className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">
                    Important Note
                  </h4>
                  <p className="text-blue-800">
                    <strong>Note:</strong> Some benefits may have usage
                    restrictions or require prior booking. Please contact the
                    club administration for detailed terms and conditions of
                    your membership.
                    <span className="block mt-2 text-sm">
                      For assistance, visit the club office or contact +880 1766
                      693142
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Documents Tab */}
        {activeTab === "documents" && (
          <div className="space-y-8">
            {/* Digital Membership Card */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 rounded-xl bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center flex-shrink-0">
                    <QrCode className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Digital Membership Card
                    </h3>
                    <p className="text-gray-600">
                      Your virtual membership identification for club access
                    </p>
                    <div className="mt-4 p-4 bg-gradient-to-r from-emerald-50 to-lime-50 rounded-lg border border-emerald-100">
                      <p className="text-sm text-gray-700">
                        {member.registrationStatus === "ACTIVE"
                          ? "Your digital membership card is ready for download and use."
                          : "Your digital membership card will be available once your membership is activated."}
                      </p>
                    </div>
                  </div>
                </div>

                <button
                  className={`px-6 py-3 rounded-xl font-bold text-white transition-all duration-300 flex items-center gap-2 ${
                    member.registrationStatus === "ACTIVE"
                      ? "bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 shadow-lg hover:shadow-xl"
                      : "bg-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() =>
                    toast.success(
                      "Membership card download feature coming soon!"
                    )
                  }
                  disabled={member.registrationStatus !== "ACTIVE"}
                >
                  <Download className="w-5 h-5" />
                  Download Card
                </button>
              </div>
            </div>

            {/* Important Documents */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <FileText className="w-6 h-6 text-emerald-500" />
                Important Documents
              </h3>

              <div className="grid md:grid-cols-2 gap-4">
                <button
                  className="group bg-gradient-to-b from-gray-50 to-gray-100 hover:from-white hover:to-gray-50 rounded-xl p-5 border border-gray-200 hover:border-emerald-200 transition-all duration-300 text-left"
                  onClick={() =>
                    toast.success(
                      "Membership terms document download coming soon!"
                    )
                  }
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center">
                      <FileCheck className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-bold text-gray-900 mb-1">
                        Membership Agreement
                      </h4>
                      <p className="text-sm text-gray-600">
                        Terms and conditions of your membership
                      </p>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-500 group-hover:translate-x-1 transition-all duration-300" />
                  </div>
                </button>

                <button
                  className="group bg-gradient-to-b from-gray-50 to-gray-100 hover:from-white hover:to-gray-50 rounded-xl p-5 border border-gray-200 hover:border-emerald-200 transition-all duration-300 text-left"
                  onClick={() =>
                    toast.success("Club rules document download coming soon!")
                  }
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center">
                      <Shield className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-bold text-gray-900 mb-1">
                        Club Rules & Regulations
                      </h4>
                      <p className="text-sm text-gray-600">
                        Code of conduct and facility usage rules
                      </p>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-blue-500 group-hover:translate-x-1 transition-all duration-300" />
                  </div>
                </button>
              </div>
            </div>

            {/* Submitted Documents */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-amber-500 to-orange-500 flex items-center justify-center">
                  <Eye className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    Submitted Documents
                  </h3>
                  <p className="text-gray-600">
                    Your uploaded documents and verifications
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-6 border border-amber-100">
                <div className="text-center">
                  <FileText className="w-12 h-12 text-amber-400 mx-auto mb-4" />
                  <h4 className="text-lg font-semibold text-amber-800 mb-2">
                    Document Management Coming Soon
                  </h4>
                  <p className="text-amber-700">
                    Your submitted documents are securely stored with the
                    administration. You'll soon be able to view and manage them
                    here.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default MembershipDetails;
